import React from 'react';
import { useStepper } from '~/components/@tem-ui/Stepper';
import { SelectLocal } from '~/components/SelectLocal';
import { useAppointment } from '~/hooks/appointment';

interface SchedulePreferenceProp {
  setFlowDate?: () => void;
}


export const ScheduleLocal = ({ setFlowDate }: SchedulePreferenceProp): JSX.Element => {
  const { nextStep } = useStepper();
  const { appointment, setAppointment } = useAppointment();

  return (
      <SelectLocal
        title="Minha Localização"
        subtitle="Informe a localização que deseja ter como referência para seu agendamento."
        onConfirmedLocation={({ street, state, city, neighborhood, postalCode, number }) => {


          const address = {
            street: street ?? '',
            state: state ?? '',
            city: city ?? '',
            neighborhood: neighborhood,
            cep: postalCode?.replace(/(?<=\d{5})-(?=\d{3})/, "") ?? '',
            lat: neighborhood && neighborhood[0]?.latitude,
            long: neighborhood && neighborhood[0]?.latitude,
            number: number
          };

          setAppointment({ ...appointment, address });
          nextStep();
        }}
      />
  );
};